import React from "react";
import Loader from "../Loader/Loader";

export default function MyPictureSection({
  t,
  parsedUserProfile,
  loading,
  savingImage,
  tempImage,
  fileInputRef,
  handleImageChange,
  deleteImg,
  saveImage,
  setTempImage,
}) {
  return (
    <div
      id="section4"
      className="flex flex-col items-center gap-2 rounded-2xl mt-6"
    >
      <div className="relative w-full text-center">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300"></div>
        </div>
        <span className="relative bg-[var(--bg)] px-3 text-lg font-bold text-[var(--brand)] uppercase tracking-wider">
          {t("user_home.my_picture")}
        </span>
      </div>
      {!parsedUserProfile?.image && (
        <p>{t("user_home.upload_picture")}</p>
      )}
      <div className="relative border-[1px] p-1 border-[#000000] w-[120px] h-[120px] md:w-[200px] md:h-[200px] rounded-full flex items-center justify-center">
        {loading || savingImage ? (
          <Loader />
        ) : (
          <img
            src={
              tempImage ||
              (parsedUserProfile?.image
                ? `${parsedUserProfile?.image}`
                : "https://res.cloudinary.com/do6t8sxgo/image/upload/v1724686661/Nobody_bao3i5.svg")
            }
            alt="userProfileImage"
            className="w-full h-full object-cover rounded-full"
          />
        )}
      </div>

      <div className="flex gap-2 mt-1 md:mt-5">
        <button
          className="bg-[var(--brand)] rounded-[5px] text-white py-0.5 px-3"
          onClick={() => fileInputRef.current.click()}
        >
          {t("generic.edit")}
        </button>
        {tempImage === null && parsedUserProfile?.image && (
          <button
            className="bg-[var(--brand)] rounded-[5px] py-0.5 px-3 text-white"
            onClick={deleteImg}
          >
            {t("generic.delete")}
          </button>
        )}
        {tempImage !== null && (
          <div className="flex gap-2">
            <button
              className="bg-[var(--brand)] rounded-[5px] py-0.5 px-3 text-white"
              onClick={saveImage}
            >
              {t("generic.save")}
            </button>
            <button
              className="bg-[var(--brand)] rounded-[5px] py-0.5 px-3 text-white"
              onClick={(e) => setTempImage(null)}
            >
              {t("generic.cancel")}
            </button>
          </div>
        )}
      </div>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept="image/*"
        onChange={handleImageChange}
      />
    </div>
  );
}
